export let Fetch = null;
export const setFetchInstance = fetchInstance => {
  Fetch = fetchInstance;
};